import { render, staticRenderFns } from "./Secure.vue?vue&type=template&id=755aad66&scoped=true"
import script from "./Secure.vue?vue&type=script&lang=ts"
export * from "./Secure.vue?vue&type=script&lang=ts"
import style0 from "./Secure.vue?vue&type=style&index=0&id=755aad66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755aad66",
  null
  
)

export default component.exports